import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicFloatingPoint = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="FLOATING POINT REPRESENTATIONS"
      videos={[
        "https://www.youtube.com/embed/e_J9lXnU_vs"
      ]}
      takeaways={[
        { text: "If the question is of 5 marks they will simply ask how to represent the numbers in single precision and double precision" },
        { text: "If the question is of 10 marks entire theory will be asked with some examples (this topic is the easiest from this module)" }
      ]}
      questions={[]}
      exampleVideos={[]}
    />
);
}

export default ModuleSubtopicFloatingPoint;